import { render, staticRenderFns } from "./genre-options.vue?vue&type=template&id=259c98a3"
import script from "./genre-options.vue?vue&type=script&lang=js"
export * from "./genre-options.vue?vue&type=script&lang=js"
import style0 from "./genre-options.vue?vue&type=style&index=0&id=259c98a3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports